// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comp {\r\n\tmin-width: calc(70% - 0px) !important;\r\n\tmin-width: calc(80% - 0px) !important;\r\n\tposition: absolute !important;\r\n\ttop: unset !important;\r\n\tleft: unset !important;\r\n\tbottom: unset !important;\r\n\tright: unset !important;\r\n}\r\n\r\n.videoComp {\r\n\tmax-height: -webkit-fill-available !important;\r\n\tmax-width: -webkit-fill-available !important;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
